let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
    items.forEach(item => {
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        item.querySelector("ul").addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      item.addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    });
});

$('.home_image_slider').slick({
   infinite: true,
  focusOnSelect: true,
  centerMode: true,
  centerPadding: '500px',
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 1500,
      settings: {
        centerPadding: '300px',
      }
    },
    {
      breakpoint: 1199,
      settings: {
        centerPadding: '100px',
      }
    },
    {
      breakpoint: 1199,
      settings: {
        centerPadding: '50px',
      }
    }
  ]
});

if($(window).width() >= '749'){
$(".tab_content").hide();
		$(".tab_content:first").show();

		/* if in tab mode */
		$("ul.tabs li").click(function() {
		    
		  $(".tab_content").hide();
		  var activeTab = $(this).attr("rel"); 
		  $("#"+activeTab).fadeIn();		
		    
		  $("ul.tabs li").removeClass("active");
		  $(this).addClass("active");

		  $(".tab_drawer_heading").removeClass("d_active");
		  $(".tab_drawer_heading[rel^='"+activeTab+"']").addClass("d_active");
		  
		});
}  
		/* if in drawer mode */
jQuery(".tab_drawer_heading").click(function(){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".tab_drawer_heading").removeClass("show");
          jQuery(".tab_drawer_heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
});

$(document).ready(function () {
  var $slider = $('.home_collection_upper');
  var $progressBar = $('.progress-bar');

  $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
    var slideIndex = (currentSlide ? currentSlide : 0) + 1; // Current slide index (0-based)
    var progress = (slideIndex / slick.slideCount) * 100; // Calculate progress percentage
    $progressBar.css('width', progress + '%'); // Update progress bar width
  });

  $slider.slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true, 
    dots: false,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      }
    ]
  });
});

$('.home_announcement_inner').slick({
  arrows:false,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 989,
      settings: {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow:2,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});

jQuery(".footer-block--menu .footer-block__heading").click(function(){
  if($(window).width() <= '749'){
  if(jQuery(this).hasClass("show"))
        {
          jQuery(this).removeClass("show");jQuery(this).next().slideUp();}
  else
        {
          jQuery(".footer-block--menu .footer-block__heading").removeClass("show");
          jQuery(".footer-block--menu .footer-block__heading").next().slideUp();
          jQuery(this).addClass("show");jQuery(this).next().slideDown();
        }
    }
});